//@flow
import * as React from 'react';

export type TaskCard$Props = {
    auth: any,
    task: any,
    taskClick: (task:any) => mixed
}

export default class TaskCard extends React.Component<TaskCard$Props> {

    taskClick(){
      this.props.taskClick(this.props.task);
    }
  
    renderProgressBar=(totalRecords:number,totalSubmited:number)=>{
      let progress=(totalSubmited/totalRecords) * 100;
      if (isNaN(progress)){
         progress=0;
      }else {
        progress=Math.ceil(progress);
      }
      return (
        <div className="progress">
          <div className="progress-bar" role="progressbar" style={{width: `${progress}%`}} aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100">{progress}%</div>
        </div>
      )
    }
  
    getWorkerTaskStat=(paramWorkerTaskStats:any)=>{
      const { user } = this.props.auth;
      let workerTaskStats = paramWorkerTaskStats.filter((wts)=>wts.worker_id==user.id)
      return workerTaskStats.length>0?workerTaskStats[0]:null;
    }
  
    render(){
      const {id,task_name,total_records,total_accepted,total_submited,total_available, task_type, workerTaskStats} = this.props.task;
      let totalAvailable=total_available;
      let totalRecords=total_records;
      let totalAccepted=total_accepted;
      let totalSubmitted=total_submited;
      let trainOrQualiModeLoading=false;
  
      if (workerTaskStats && (task_type==='TRAIN' || task_type==='QUALI')){
         const wts=this.getWorkerTaskStat(workerTaskStats)
         if (wts){
            totalAvailable=wts.total_available;
            totalRecords=wts.total_records;
            totalAccepted=wts.total_accepted;
            totalSubmitted=wts.total_submitted;
         }
      }else {
        if (totalAvailable && (task_type==='TRAIN' || task_type==='QUALI') && !workerTaskStats){
            trainOrQualiModeLoading=true;
        }
      }
      
      if (totalAvailable && !trainOrQualiModeLoading){
        return (
          <div key={id} className="col-sm-4">
            <div className="card taskCategoryContainer" onClick={this.taskClick.bind(this)}>
              <div className="card-body">
                <h4 className="card-title">{task_name}</h4>
                {this.renderProgressBar(totalRecords,totalSubmitted)}
                <p className="card-text">Total Tasks: {totalRecords}</p>
                <p className="card-text">Tasks Accepted: {totalAccepted}</p>
                <p className="card-text">Tasks Available: {totalAvailable}</p>
              </div>
            </div>
          </div>
        );
      }else{
        if (totalAccepted){
          return (
            <div key={id} className="col-sm-4">
              <div className="card taskCategoryContainer" onClick={this.taskClick.bind(this)} >
                <div className="card-body">
                  <h4 className="card-title">{task_name}</h4>
                  {this.renderProgressBar(totalRecords,totalSubmitted)}
                  <p className="card-text">Total Tasks: {totalRecords}</p>
                  <p className="card-text">Tasks Accepted: {totalAccepted}</p>
                  <p className="card-text">Tasks Available: {totalAvailable}</p>
                </div>
              </div>
            </div>
          );
        }else {
          if (trainOrQualiModeLoading){
            const msg=`You have ${task_type==='TRAIN'?'training':'qualification'} tasks. Please wait...`
            return (
              <div key={id} className="col-sm-4">
                <div className="card" style={{width: 300}}>
                  <div className="card-body">
                    <h4 className="card-title">{task_name}</h4>
                    <p className="card-text">{msg}</p>
                  </div>
                </div>
              </div>
            );
          }else {
            return (
              <div key={id} className="col-sm-4">
                <div className="card" style={{width: 300}}>
                  <div className="card-body">
                    <h4 className="card-title">{task_name}</h4>
                    <p className="card-text">Task not available!</p>
                  </div>
                </div>
              </div>
            );
          }
          
        }
      }
      
    }
  }


// WEBPACK FOOTER //
// ./src/views/ProjectTasks/TaskCard.js